<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage tigerEtfview"
  >
    <header-area />

    <div class="worksView" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              Every Subject You Imagine is<br />The Investment Target!
            </div>
            <div class="workSlogan mobile">
              Every Subject You Imagine is<br />The Investment Target!
            </div>
            <div class="workTopDay">
              <p>TIGER ETF 웹사이트 개편</p>
              <ul>
                <li>Web site</li>
                <li>2019.06.18</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://www.tigeretf.com/" target="_blank" class="siteAddr"
                >https://www.tigeretf.com/</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/tigeretf"
                    title="상상하는 모든 주제가 투자 대상이 된다 미래에셋 TIGER ETF 웹사이트"
                    hashtags="플립커뮤니케이션즈,미래에셋,TIGER_ETF"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/tigeretf"
                    title="상상하는 모든 주제가 투자 대상이 된다 미래에셋 TIGER ETF 웹사이트"
                    hashtags="플립커뮤니케이션즈,미래에셋,TIGER_ETF"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="20"
              >&nbsp;Every Subject You Imagine is The Investment Target!</marquee-text
            ></span
          >
          <img src="@/assets/images/works_view/tiger_etf/tiger_visual.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          TIGER ETF는 국내에서 가장 많은 상품을 보유하고 있는 미래에셋자산운용의 ETF 브랜드입니다.
          국내 경제가 장기적 저성장 기조를 보이고 개인 펀드 투자자들이 지속적으로 증가하는 상황에서,
          TIGER ETF는 이번 웹사이트 리뉴얼을 통해 모든 사용자가 차별 없이 투자 정보에 접근할 수 있는
          환경을 구축하고자 했습니다. PC 환경이든 모바일 환경이든, 정보 접근 약자이든 아니든 투자에
          관심 있는 사람이라면 누구에게나 양질의 투자 정보를 제공해 투자의 진입 장벽을 낮추고 수익
          창출을 돕고자 했습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <!-- TOP -->
        <div class="tigerTop">
          <div class="worksView">
            <strong class="topText">[ 소액 투자의 바이블을 쓰다 ]</strong>
            <div class="topIco">
              <!-- img 01~05까지 자동 로테이션 -->
              <div
                class="slide"
                :class="{ active: icoVal === 0, prev: icoVal === 4, next: icoVal === 1 }"
              >
                <img src="@/assets/images/works_view/tiger_etf/ico_top_01.png" alt="" />
              </div>
              <div
                class="slide"
                :class="{ active: icoVal === 1, prev: icoVal === 0, next: icoVal === 2 }"
              >
                <img src="@/assets/images/works_view/tiger_etf/ico_top_02.png" alt="" />
              </div>
              <div
                class="slide"
                :class="{ active: icoVal === 2, prev: icoVal === 1, next: icoVal === 3 }"
              >
                <img src="@/assets/images/works_view/tiger_etf/ico_top_03.png" alt="" />
              </div>
              <div
                class="slide"
                :class="{ active: icoVal === 3, prev: icoVal === 2, next: icoVal === 4 }"
              >
                <img src="@/assets/images/works_view/tiger_etf/ico_top_04.png" alt="" />
              </div>
              <div
                class="slide"
                :class="{ active: icoVal === 4, prev: icoVal === 3, next: icoVal === 0 }"
              >
                <img src="@/assets/images/works_view/tiger_etf/ico_top_05.png" alt="" />
              </div>
            </div>
            <div
              class="tigerSlogan lineArea"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <p>Every subject <span>You imagine is</span></p>
              <p>The investment Target!</p>
            </div>
          </div>

          <div class="tigerTopImgArea">
            <ul class="blurCyc">
              <kinesis-element tag="li" :strength="100" class="cyclePink" axis="y" type="translate">
                <img src="@/assets/images/works_view/tiger_etf/cycle_p.png" alt="" />
              </kinesis-element>
            </ul>

            <kinesis-container event="scroll" :duration="0">
              <kinesis-element
                tag="ul"
                class="topImg web"
                :origin-y="0"
                :strength="W * -0.35"
                axis="y"
                type="translate"
              >
                <li>
                  <div>
                    <img src="@/assets/images/works_view/tiger_etf/top_img1.png" alt="" />
                  </div>
                </li>
                <li class="topImg2">
                  <div>
                    <img src="@/assets/images/works_view/tiger_etf/top_img2.png" alt="" />
                  </div>
                </li>
                <li>
                  <div>
                    <img src="@/assets/images/works_view/tiger_etf/top_img3.png" alt="" />
                  </div>
                </li>
              </kinesis-element>
              <kinesis-element
                tag="ul"
                class="topImg mobile"
                :origin-y="0"
                :strength="-W * 1.5"
                axis="y"
                type="translate"
              >
                <li>
                  <div>
                    <img src="@/assets/images/works_view/tiger_etf/mob_top_img1.png" alt="" />
                  </div>
                </li>
                <li class="topImg2">
                  <div>
                    <img src="@/assets/images/works_view/tiger_etf/mob_top_img2.png" alt="" />
                  </div>
                </li>
                <li>
                  <div>
                    <img src="@/assets/images/works_view/tiger_etf/mob_top_img3.png" alt="" />
                  </div>
                </li>
              </kinesis-element>
            </kinesis-container>
            <kinesis-container tag="ul" class="blurCyc" event="scroll">
              <kinesis-element
                tag="li"
                :strength="-200"
                class="cycleRed"
                axis="y"
                type="translate"
                style="height: 100vw!important;"
              >
                <img src="@/assets/images/works_view/tiger_etf/cycle_r.png" alt="" />
              </kinesis-element>
              <kinesis-element tag="li" :strength="200" class="cycleBlue" axis="y" type="translate">
                <img src="@/assets/images/works_view/tiger_etf/cycle_b.png" alt="" />
              </kinesis-element>
              <kinesis-element
                tag="li"
                :strength="-100"
                class="cycleGreen"
                axis="y"
                type="translate"
              >
                <img src="@/assets/images/works_view/tiger_etf/cycle_g.png" alt="" />
              </kinesis-element>
            </kinesis-container>
          </div>
        </div>
        <!-- //TOP -->

        <!-- Concept -->
        <div class="tigerConcept" style="margin-top: -20vw;">
          <div class="worksView">
            <div
              class="contsBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tigerTitle web">
                <span class="tigerNum">Concept</span>
                <strong class="tigerTxt mo-typo01">
                  <span class="tiger_line">상상하는 모든 주제가 투자 대상!</span><br />
                  정보는 빠르게 투자는 쉽게!
                </strong>
              </div>

              <div class="tigerTitle mobile">
                <span class="tigerNum">Concept</span>
                <strong class="tigerTxt">
                  <span class="tiger_line">상상하는 모든 주제가<br />투자 대상!</span><br />
                  정보는 빠르게 투자는 쉽게!
                </strong>
              </div>

              <div class="tiger_text">
                미래에셋자산운용의 테마형 ETF는 안정적인 성향의 투자가들이 선호하는 투자 상품으로,
                내가 좋아하는 주제가 곧 투자 대상이 되는 상품입니다. 다양한 상품의 특징과 테마를
                탐색하고, 관심 상품을 모아 비교해보는 데 최적화된 기능을 제공해 투자자들이 언제든
                수익 창출을 위한 핵심 정보를 즉각적으로 확인할 수 있도록 구현했습니다. 또한 투자
                상품에 대한 설명 뿐만 아니라 투자 위험에 대해서도 함께 고지함으로써 개인(소액)
                투자자들이 안심하고 투자할 수 있도록 배려했습니다.
              </div>
            </div>

            <kinesis-container event="scroll" :duration="100">
              <div
                class="conceptCycle lineArea"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="contsBox">
                  <div class="cycleInner">
                    <ul
                      class="cCycAreaUl"
                      v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                    >
                      <li class="cCycLiSecond">
                        <div class="cCycTit">
                          정보의 최적화
                        </div>
                        <div class="cCycText">
                          <ul>
                            <li>Reducti on</li>
                            <li>Minimal</li>
                            <li>Visulization</li>
                          </ul>
                        </div>
                      </li>
                      <li class="cCycLiSecond">
                        <div class="cCycTit">
                          쉽고빠른 탐색
                        </div>
                        <div class="cCycText">
                          <ul>
                            <li>Directly</li>
                            <li>Accessibility</li>
                            <li>Easy</li>
                          </ul>
                        </div>
                        <span class="opacityCyc" />
                        <span class="opacityCyc" />
                      </li>
                      <li class="cCycLiSecond">
                        <div class="cCycTit">
                          브랜드 제고
                        </div>
                        <div class="cCycText">
                          <ul>
                            <li>Identity</li>
                            <li>Consistency</li>
                            <li>Safety</li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </kinesis-container>
          </div>
        </div>
        <!-- //Concept -->

        <!-- section_1 : Focus1 -->
        <div class="tigerSection1">
          <div class="grayBgInner">
            <div class="worksView">
              <div class="contsBox">
                <div class="tigerTitle">
                  <span class="tigerNum">Focus 1 : Information</span>
                  <strong class="tigerTxt">
                    고객에게 유익한
                    <span class="tiger_line">투자 정보를 쉽고, 빠르게</span>
                  </strong>
                </div>

                <div class="tiger_text">
                  다양한 상품과 산재된 투자 정보들 속에서 투자자들이 원하는 상품을 찾기란 쉽지
                  않습니다. 그렇기 때문에 투자 상품을 검색하고 상세 내용을 확인해 관심 상품으로
                  등록하는 일련의 과정은 무엇보다 일목요연하게 구성돼야 합니다. 각각의 상품별 자료
                  조회를 한곳에서 확인할 수 있도록 구성하고, 상품을 직관적으로 파악할 수 있도록
                  제공되는 정보를 시각화했습니다. 상품 상세 정보 페이지에서 수익률, 보유 비율,
                  현재가, 기준가격, 분배금 등 실질적인 상품 운용에 필요한 정보를 우선 노출하고, 바로
                  관심 상품으로 등록할 수 있도록 구현했습니다. 또한 주요 콘텐츠를 섹션별로 나누고
                  PC와 모바일 등 각각의 환경에 맞게 아코디언 또는 카드 형태의 UI를 적용했습니다.
                </div>
              </div>

              <div class="graphInner">
                <div class="contsBox">
                  <div
                    class="infoPath"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <ul>
                      <li class="infoImg1">
                        <img src="@/assets/images/works_view/tiger_etf/info_img1.png" alt="" />
                      </li>
                      <li class="infoImg2">
                        <img src="@/assets/images/works_view/tiger_etf/info_img2.png" alt="" />
                      </li>
                    </ul>
                  </div>

                  <div
                    class="tigerSnsBtn"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <ul>
                      <li>
                        <img src="@/assets/images/works_view/tiger_etf/ico_sns1.png" alt="" />
                      </li>
                      <li>
                        <img src="@/assets/images/works_view/tiger_etf/ico_sns2.png" alt="" />
                      </li>
                      <li>
                        <img src="@/assets/images/works_view/tiger_etf/ico_sns3.png" alt="" />
                      </li>
                    </ul>
                    <div class="tigerSnsTxt">
                      <p>
                        해당 사이트 외에도 블로그, 페이스북, 유튜브 등 다양한 SNS로 쉽게 연계할 수
                      </p>
                      <p>
                        있도록 하고, 이와 동시에 테마 상품별로 뉴스레터를 제공함으로써 신규 상품 및
                      </p>
                      <p>관심 상품에 대한 정보 획득의 편리성을 높였습니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="graphBg"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="web">
                <img src="@/assets/images/works_view/tiger_etf/bg_graph.png" alt="" />
              </div>
              <div class="mobile">
                <img src="@/assets/images/works_view/tiger_etf/mob_bg_graph.png" alt="" />
              </div>
            </div>
          </div>

          <div class="worksView" style="margin-top: 5vw;">
            <div class="secondaryCell">
              <strong class="secCellTit">
                <img src="@/assets/images/works_view/tiger_etf/ico_car.jpg" alt="" />
              </strong>
              <div class="secCellImg">
                <marquee-text :duration="20">
                  <img src="@/assets/images/works_view/tiger_etf/group_img.png" alt="" />
                </marquee-text>
              </div>
            </div>
          </div>
        </div>
        <!-- //section_1 : Focus1 -->

        <!-- section_2 : Focus2 -->
        <div class="tigerSection2">
          <div
            class="tigerSInr1"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="areaGray">
              <div class="areaGrayInr">
                <div class="worksView">
                  <div class="contsBox">
                    <div class="tigerTitle">
                      <span class="tigerNum">Focus 2 : Usability</span>
                      <strong class="tigerTxt">
                        테마/태그 검색 개선
                      </strong>
                    </div>

                    <div class="tiger_text">
                      우리나라는 해외 ETF보다 늦은 2017년 이후에야 관심 대상(주제)에 투자하는 테마
                      ETF에 대한 관심이 생겨나기 시작했습니다. 새롭게 개편된 TIGER ETF
                      웹사이트에서는 낯설고 어려웠던 기존의 ETF 상품 접근 방식을 개선, 카테고리 및
                      태그 등을 이용해 관심 주제를 검색하고 상품에 접근하는 것이 한층 더
                      쉬워졌습니다.
                    </div>
                    <div class="usabilityMockup">
                      <img
                        src="@/assets/images/works_view/tiger_etf/img_usebility_phone_01.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tigerSInr2">
            <div class="worksView">
              <div class="contsBox">
                <ul class="tagGroup">
                  <li
                    class="tag01"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_01.png" alt="" />
                  </li>
                  <li
                    class="tag02"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_02.png" alt="" />
                  </li>
                  <li
                    class="tag03"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_03.png" alt="" />
                  </li>
                  <li
                    class="tag04"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_04.png" alt="" />
                  </li>
                  <li
                    class="tag05"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_05.png" alt="" />
                  </li>
                  <li
                    class="tag06"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_06.png" alt="" />
                  </li>
                  <li
                    class="tag07"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_07.png" alt="" />
                  </li>
                  <li
                    class="tag08"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_08.png" alt="" />
                  </li>
                  <li
                    class="tag09"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_09.png" alt="" />
                  </li>
                  <li
                    class="tag10"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_10.png" alt="" />
                  </li>
                  <li
                    class="tag11"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_11.png" alt="" />
                  </li>
                  <li
                    class="tag12"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_12.png" alt="" />
                  </li>
                  <li
                    class="tag13"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_13.png" alt="" />
                  </li>
                  <li
                    class="tag14"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_14.png" alt="" />
                  </li>
                  <li
                    class="tag15"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_15.png" alt="" />
                  </li>
                  <li
                    class="tag16"
                    v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  >
                    <img src="@/assets/images/works_view/tiger_etf/img_theme_16.png" alt="" />
                  </li>
                </ul>
                <div class="themeMockup01">
                  <img src="@/assets/images/works_view/tiger_etf/img_theme_phone_01.png" alt="" />
                </div>
                <div class="themeMockup02">
                  <img src="@/assets/images/works_view/tiger_etf/img_theme_phone_02.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <kinesis-container event="scroll" :duration="0">
            <div class="tigerSInr3">
              <kinesis-element
                tag="div"
                class="worksView"
                :origin-y="W < 890 ? W / 4 : W / 7"
                :strength="W < 890 ? -W * 0.5 : -W / 10"
                axis="y"
                type="translate"
              >
                <div class="contsBox">
                  <div class="tigerTitle">
                    <strong class="tigerTxt">
                      상품 수익률 비교 개선
                    </strong>
                  </div>
                  <div class="tiger_text">
                    기존 마이페이지의 정보를 재정렬하고 ETF 상품에 맞춰 관심 정보를 비교할 수 있도록
                    개편했습니다. 차트 솔루션을 통해 수익률, 현재가, 기준가 등의 상품 추이를 쉽게
                    가늠할 수 있도록 하고, 비교하기 기능으로 다양한 상품을 직관적으로 비교할 수
                    있도록 구현했습니다.
                  </div>
                  <div class="compareLine">
                    <span class="easy">Easy</span>
                    <span class="compare">Compare</span>
                  </div>
                  <div class="compareMockup">
                    <div class="web">
                      <img
                        src="@/assets/images/works_view/tiger_etf/img_compare_phone.png"
                        alt=""
                      />
                    </div>
                    <div class="mobile">
                      <img
                        src="@/assets/images/works_view/tiger_etf/mob_img_compare_phone.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </kinesis-element>
            </div>
          </kinesis-container>
        </div>
        <!-- //section_2 : Focus2 -->

        <!-- section_3 : Focus3 -->
        <kinesis-container event="scroll" :duration="0">
          <kinesis-element
            tag="div"
            class="tigerSection3"
            :origin-y="W < 890 ? W / 3 : W / 4.5"
            :strength="W < 890 ? -W * 0.5 : -W / 10"
            axis="y"
            type="translate"
          >
            <div class="worksView">
              <div class="contsBox">
                <div class="tigerTitle">
                  <span class="tigerNum">Focus 3 : Manage system</span>
                  <strong class="tigerTxt">
                    <span>간편로그인 및</span> 관리 시스템 기능 강화
                  </strong>
                </div>

                <div class="tiger_text">
                  기존 SNS 계정을 활용한 간편 가입 및 로그인 기능을 추가해 신규 고객의 서비스
                  사용성을 강화하고자 했습니다. 이를 통해 가입 고객의 상품 조회 및 ETF 시장 리포트
                  조회 등의 데이터를 산출하고 테마형 상품에 대한 고객들의 관심도를 파악해 향후 연계
                  상품 개발 및 마케팅에 활용할 수 있도록 개발했습니다. 또한 ETF 상품의 경우 사회적
                  이슈 또는 트렌드에 많은 영향을 받는 상품인 점을 감안해 기간별 페이지 뷰 현황 및
                  상품 추이를 파악할 수 있도록 구글 애널리틱스를 적용했습니다.
                </div>
                <div
                  class="manageMockup"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <img src="@/assets/images/works_view/tiger_etf/img_manage_phone.png" alt="" />
                </div>
                <ul
                  class="snsList"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <li class="gl">
                    <img src="@/assets/images/works_view/tiger_etf/ico_sns_gl.png" alt="" />
                  </li>
                  <li class="nv">
                    <img src="@/assets/images/works_view/tiger_etf/ico_sns_nv.png" alt="" />
                  </li>
                  <li class="kakao">
                    <img src="@/assets/images/works_view/tiger_etf/ico_sns_kakao.png" alt="" />
                  </li>
                  <li class="fb">
                    <img src="@/assets/images/works_view/tiger_etf/ico_sns_fb.png" alt="" />
                  </li>
                </ul>
              </div>
            </div>
          </kinesis-element>
          <kinesis-element
            tag="div"
            class="tigerSection4"
            :origin-y="W < 890 ? W / 2.5 : W / 3.8"
            :strength="W < 890 ? -W * 0.5 : -W / 10"
            axis="y"
            type="translate"
          >
            <div class="tigerSection4">
              <div class="worksView">
                <div class="contsBox" style="padding-top: 0;">
                  <div class="tigerTitle">
                    <span class="tigerNum">Focus 4 : Branding</span>
                    <strong class="tigerTxt">
                      <span class="tiger_line">TIGER ETF BI</span> 제고
                    </strong>
                  </div>

                  <div class="tiger_text">
                    미래에셋자산운용의 ETF 브랜드인 TIGER ETF는 이번 프로젝트를 통해
                    미래에셋자산운용의 글로벌 플랫폼뿐만 아니라 다른 경쟁사와 차별화된 브랜드
                    아이덴티티를 확립하고, 브랜드 인지도를 강화하고자 했습니다. 홈페이지는 TIGER ETF
                    로고타입을 모티프로 제작됐습니다. 주요 3색 컬러인 오렌지, 레드, 그레이를 UI의
                    핵심적 역할을 하는 GNB, 버튼, 타이틀, 검색 영역에 일관된 형태로 적용했으며,
                    브랜드의 핵심인 상품 역시 각각의 주제에 맞는 아이콘을 개발해 사용자들이 독자적인
                    브랜드 경험을 할 수 있도록 구현했습니다.
                  </div>

                  <div class="bImg01">
                    <img src="@/assets/images/works_view/tiger_etf/img_gnb_01.png" alt="" />
                  </div>
                  <div class="biImg02">
                    <img src="@/assets/images/works_view/tiger_etf/img_gnb_02.png" alt="" />
                  </div>
                  <div class="biImgJustify">
                    <div class="biImg03">
                      <img src="@/assets/images/works_view/tiger_etf/img_guide_01.png" alt="" />
                    </div>
                    <div class="biImg04Wrap">
                      <div class="biImg04">
                        <img src="@/assets/images/works_view/tiger_etf/img_guide_02.png" alt="" />
                      </div>
                      <div class="biImg0401">
                        <img src="@/assets/images/works_view/tiger_etf/img_guide_03.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="logoView">
                <div class="logoImg">
                  <img src="@/assets/images/works_view/tiger_etf/img_logo_bi.png" alt="" />
                </div>
                <span
                  class="logoImgEm01"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  ><img src="@/assets/images/works_view/tiger_etf/img_logo_bi_em_01.png" alt=""
                /></span>

                <span
                  class="logoImgEm02"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  ><img src="@/assets/images/works_view/tiger_etf/img_logo_bi_em_02.png" alt=""
                /></span>

                <span
                  class="logoImgEm03"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                  ><img src="@/assets/images/works_view/tiger_etf/img_logo_bi_em_03.png" alt=""
                /></span>
              </div>
              <div class="biIconWrap">
                <div class="biIcon">
                  <div class="icon">
                    <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_01.png" alt="" />
                  </div>
                  <span class="iconEm01">
                    <div class="web">
                      <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_em.png" alt="" />
                    </div>

                    <div class="mobile">
                      <img
                        src="@/assets/images/works_view/tiger_etf/mob_img_bi_icon_em.png"
                        alt=""
                      />
                    </div>
                  </span>
                  <span class="iconEm02">
                    <div class="web">
                      <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_em.png" alt="" />
                    </div>

                    <div class="mobile">
                      <img
                        src="@/assets/images/works_view/tiger_etf/mob_img_bi_icon_em.png"
                        alt=""
                      />
                    </div>
                  </span>
                  <span class="iconEm03">
                    <div class="web">
                      <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_em.png" alt="" />
                    </div>

                    <div class="mobile">
                      <img
                        src="@/assets/images/works_view/tiger_etf/mob_img_bi_icon_em.png"
                        alt=""
                      />
                    </div>
                  </span>
                </div>
                <ul class="biIconList">
                  <li class="list01">
                    <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_02.png" alt="" />
                  </li>
                  <li class="list02">
                    <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_03.png" alt="" />
                  </li>
                  <li class="list03">
                    <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_04.png" alt="" />
                  </li>
                  <li class="list04">
                    <img src="@/assets/images/works_view/tiger_etf/img_bi_icon_05.png" alt="" />
                  </li>
                </ul>
              </div>
              <div class="lineWrap">
                <div class="line">
                  <img src="@/assets/images/works_view/tiger_etf/img_bi_line.png" alt="" />
                </div>
                <div class="logo">
                  <img src="@/assets/images/works_view/tiger_etf/img_bi_line_logo.png" alt="" />
                </div>
                <span class="color01">#E7280F</span>
                <span class="color02">#ED7100</span>
                <span class="color03">#777576</span>
              </div>
            </div>

            <div class="worksView">
              <div class="contsBox">
                <div class="backToList">
                  <router-link :to="{ name: 'works' }" class="backBtn">
                    <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
                    <span>Back to list</span>
                  </router-link>
                </div>
              </div>

              <router-link v-if="true" :to="{ name: 'works-jejuY' }" class="longEnd vType">
                <div class="viewType">
                  <span>next</span>
                  <strong class="web">오리온 제주용암수</strong>
                  <strong class="mobile">오리온<br />제주용암수</strong>
                </div>

                <div class="engBg tigerEEndBg">
                  <span />
                </div>
              </router-link>
            </div>

            <footer-area />
          </kinesis-element>
        </kinesis-container>
        <!-- //section_4 : Focus4 -->
      </div>
    </kinesis-container>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '미래에셋 TIGER ETF'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "미래에셋자산운용 타이거 ETF 홈페이지 | 플립커뮤니케이션즈",
        title: "미래에셋자산운용 타이거 ETF 홈페이지",
        desc:
          "TIGER ETF 웹사이트 리뉴얼을 통해 투자자들이 쉽고 빠르게 원하는 투자 정보를 얻을 수 있도록 UI/UX를 개선하고, 테마/태그 검색 등을 통해 상품 접근성을 높였습니다. 또한 수익률 비교 기능 강화, 간편 가입/로그인 추가 등 관리 시스템을 개선하고, 고유의 브랜드 아이덴티티를 구축하여 브랜드 인지도를 높이고자 했습니다.",
        keywords:
          "TIGER ETF, 웹사이트 개편, 미래에셋자산운용, 국내 ETF, 상품 보유, 투자 정보, 투자자, 투자 대상, 모바일 환경, 소액 투자, 테마형 ETF, 수익 창출, 정보 접근, 브랜드 제고, 투자 위험",
        url: "https://www.pulip.com/works/tigerEtf",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/tigeretf").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    // this.iconSwiper = new window.Swiper('.topIco.swiper-container', {
    //   effect: 'fade',
    //   slidesPerView: 1,
    //   // loop: true,
    //   allowTouchMove: false,
    //   grabCursor: true,
    //   autoplay: {
    //     delay: 3000
    //   }
    // })
    this.icoInter = setInterval(() => {
      this.icoVal++;
      if (this.icoVal > 4) this.icoVal = 0;
    }, 800);
  }
};
</script>
<style>
.topIco .slide {
  opacity: 0 !important;
  transition: opacity 0.4s, transform 0.4s !important;
  position: absolute;
  top: 0;
  left: 0;
}
.topIco .slide:first-child {
  position: relative;
}
.topIco .slide.prev,
.topIco .slide.next {
  opacity: 0 !important;
  transform: scale(0.8) !important;
}
.topIco .slide.active {
  opacity: 1 !important;
  transform: scale(1) !important;
}
</style>
